import React from 'react';
import {Form} from "react-bootstrap";
import PropTypes from 'prop-types';
import {isString} from 'lodash';

const FormGroup = React.forwardRef((props, ref) => (
    <Form.Group controlId={props.name}>
        <Form.Label className={props.required && "required"}>{props.label}</Form.Label>
        {isString(props.type)
            ? <Form.Control name={props.name}
                            ref={ref}
                            {...props}/>
            : React.createElement(props.type, {...props, ref: ref})}

        <Form.Label className={props.minLength && "minLength"}></Form.Label>
        <Form.Label className={props.maxLength && "maxLength"}></Form.Label>
    </Form.Group>
));


FormGroup.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
    required: PropTypes.bool
};

FormGroup.defaultProps = {
    type: "input",
    required: false,
};

export default FormGroup;